<template>
  <div class="HmiLanding-page">
    <swiper :banners="banners"></swiper>
    <section class="section">
      <div class="section-info">
        <div class="info-box">
          <div class="title">什么是剑维软件 HMI（中国版）？</div>
          <div class="desc">
            剑维软件 HMI (中国版) 是一款本地化、跨平台的 HMI/SCADA 软件解决方案，帮助设备厂家“一次开发、多处部署”，可在 Windows、Linux 以及中国国产 IT 软硬件栈上运行；同时提供二次开发能力以构建差异化的设备应用，并具备安全、可扩展的运行时与自动化系统和工业物联网连接，赋能中国智造。
          </div>
          <a class="btn" href="https://resource.avevacommunity.com/resource/hmi/HMI.pdf" target="_blank">阅读手册</a>
        </div>
        <div class="info-img">
          <video src="https://resource.avevacommunity.com/resource/hmi/0.mp4" controls class="img"></video>
        </div>
      </div>
      <div class="section-point">
        <div class="section-title">产品亮点</div>
        <div class="point-tags">
          <div class="tag">功能齐全</div>
          <div class="tag">跨平台 多终端</div>
          <div class="tag">互联互通</div>
        </div>
        <div class="point-grid">
          <div class="grid-item" v-for="item in pointsData" :key="item.title">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="section-res">
        <div class="section-title">产品资源</div>
        <div class="res-items">
          <div class="item">
            <div class="icon"><img src="@/assets/PC/hmi/res_software.png" alt=""></div>
            <div class="text" @click="goSoftwareTraining">软件培训</div>
          </div>
          <div class="item">
            <div class="icon"><img src="@/assets/PC/hmi/res_download.png" alt=""></div>
            <div class="text" @click="handleJump('/Home/MarketingCenter?type=hmi')">资源下载</div>
          </div>
          <div class="item">
            <div class="icon"><img src="@/assets/PC/hmi/res_result.png" alt=""></div>
            <div class="text" @click="goProductFeedback">产品反馈</div>
          </div>
        </div>
      </div>
      <div class="section-btn-box" v-if="showApplyBtn">
        <div class="btn" @click="handleTry">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.64256 18H2.70534C1.21739 18 0 16.7826 0 15.2947V2.70534C0 1.21739 1.21739 0 2.70534 0H15.2947C16.7826 0 18 1.21739 18 2.70534V5.63289C18 6.05795 17.6521 6.40588 17.227 6.40588C16.802 6.40588 16.454 6.05795 16.454 5.63289V2.70534C16.454 2.06775 15.9323 1.54598 15.2947 1.54598H2.70534C2.06775 1.54598 1.54598 2.06775 1.54598 2.70534V15.2947C1.54598 15.9323 2.06775 16.454 2.70534 16.454H5.63289C6.05795 16.454 6.40588 16.802 6.40588 17.227C6.40588 17.6521 6.06762 18 5.64256 18Z" fill="currentColor"/>
            <path d="M8.66658 17.8162C8.47339 17.8162 8.27053 17.7391 8.11579 17.594C7.81622 17.2945 7.81622 16.8017 8.11579 16.5021L16.6375 7.97072C16.9371 7.67115 17.4299 7.67115 17.7294 7.97072C18.029 8.2703 18.029 8.76306 17.7294 9.06239L9.2077 17.5841C9.06286 17.7386 8.85977 17.816 8.66658 17.816V17.8162Z" fill="currentColor"/>
            <path d="M14.1063 5.82608H3.90339C3.47833 5.82608 3.1304 5.47815 3.1304 5.05309C3.1304 4.62803 3.47833 4.2801 3.90339 4.2801H14.1159C14.541 4.2801 14.8889 4.62803 14.8889 5.05309C14.8889 5.47815 14.541 5.82608 14.1063 5.82608Z" fill="currentColor"/>
            <path d="M3.90339 11.0724C3.47833 11.0724 3.1304 10.7244 3.1304 10.2994C3.1304 9.8743 3.47833 9.52637 3.90339 9.52637H9.86487C10.2899 9.52637 10.6379 9.87406 10.6379 10.2994C10.6379 10.7247 10.2899 11.0724 9.85519 11.0724H3.90339Z" fill="currentColor"/>
          </svg>
          点击申请成为 HMI 中国版试用者
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { GetBanner } from '@/api/Home.js'
import swiper from "@/components/Swiper.vue";
import { mapState } from 'vuex';
import { GetUserInfo, ApplyHmiTrial, EnsureAvevaHmiTrial } from '@/api/profile.js'

import { GetWxShares, openUrl } from '@/utils/common'
import { ApiToken } from '@/utils/ApiToken'
export default {
  name: 'HmiLanding',
  components: {
    swiper,
  },
  data () {
    return {
      banner: [],
      bannerM: [],
      applying: false,
      pointsData: [
        {
          title: '结构化标签管理与表格化工作流',
          desc: '用统一标签配置表集中管理，支持 WPS/Excel 复制粘贴批量维护；VTQ 属性满足趋势、报警、历史与审计需求。',
        },
        {
          title: '可复用、参数化图符库',
          desc: '内置标准组件支持复用；参数化绑定标签/报警/颜色等，实现全局联动更新，显著缩短项目启动时间。',
        },
        {
          title: '灵活脚本与可扩展架构',
          desc: '内置丰富脚本函数与调度调用；支持自定义组件、标准库与插件扩展，便于 OEM 封装行业知识并跨项目复用。',
        },
        {
          title: '报警与事件可追溯管理',
          desc: '支持优先级、分组筛选、确认备注等标准流程；关键操作可审计追踪，支撑合规与作业纪律。',
        },
        {
          title: '趋势与可视化（插件化）',
          desc: '提供实时/历史趋势分析与参数化配置；支持引入外部可视化插件（如 HTML5）定制体验。',
        },
        {
          title: '配方管理与受控变更',
          desc: '一键切换型号/批次关键参数，减少手工错误；配方操作可纳入事件与审计记录。',
        },
        {
          title: '电子签名与角色权限',
          desc: '关键操作需身份确认与原因说明；结合角色权限，强化安全控制与责任边界。',
        },
        {
          title: '工业连接与数据集成',
          desc: '支持 PLC、ODBC 数据库、OPC UA、MQTT 等接口，轻松对接 SCADA/MES、AIoT 与云/AI 系统。',
        },
      ],
    }
  },
  computed: {
    ...mapState(['Infos', 'clientWidth', 'token', 'Module']),
      banners() {
        const list = this.clientWidth > 750 ? this.banner : this.bannerM
        return list
      },
      // 未登录显示；已登录且尚无 HMI 身份显示；已有身份（含 AVEVA 自动补标后）不显示
      showApplyBtn() {
        if (!this.token) return true
        return !(this.Infos && this.Infos.isHmiTrial)
      },
      // 与 Forum HMI Tab 一致：试用者或 AVEVA
      hasHmiAccess() {
        if (!this.token || !this.Infos) return false
        return !!(this.Infos.isHmiTrial || String(this.Infos.partnerType) === '10852')
      },
      // 软件培训：用环境 shareUrl，测试/正式自动区分
      trainingUrl() {
        return `${ApiToken.shareUrl}Home/Product/HMIChina`
      },
      hmiChinaProductId() {
        const id = parseInt(this.Module && this.Module.hmiChinaProductId, 10)
        if (id > 0) return id
        return ApiToken.hmiChinaProductId || 0
      },
  },
  watch: {
  },
  created () {
  },
  mounted () {
    const share = {
      title: 'HMI 中国版 | 剑盟社区',
      desc: ''
    }
    GetWxShares(share);
    GetBanner().then(res=>{
      if (res.status === 1) {
        this.banner = res.data.hmi || []
        this.bannerM = res.data.hmi_m || []
      }
    })
    this.syncHmiIdentity()
  },
  destroyed () {
  },
  methods: {
    // 软件培训 / 资源下载 / 产品反馈：未登录或无 HMI 身份时提醒，不跳转
    ensureHmiAccess() {
      if (!this.token) {
        this.$toast('请登录后操作!')
        return false
      }
      if (!this.hasHmiAccess) {
        this.$toast('请先申请成为 HMI 中国版试用者!')
        return false
      }
      return true
    },
    goSoftwareTraining() {
      if (!this.ensureHmiAccess()) return
      openUrl('https://share.articulate.com/pjD5cVZiWagppK-T4my1G')
    },
    handleJump(path) {
      if (!path) return
      if (!this.ensureHmiAccess()) return
      this.$router.push(path)
    },
    goProductFeedback() {
      if (!this.ensureHmiAccess()) return
      const id = this.hmiChinaProductId
      const path = id
        ? `/Home/ForumSec/Article?type=1&productId=${id}`
        : '/Home/ForumSec/Article?type=1'
      this.$router.push(path)
    },
    refreshUserInfo() {
      return GetUserInfo().then(res => {
        if (res.status === 1) {
          // Infos 走 Info mutation；$_setStorage 只用于 token
          this.$store.commit('Info', res.data)
        }
        return res
      })
    },
    syncHmiIdentity() {
      if (!this.token) return
      // AVEVA 进页自动补齐 HMI 身份
      if (String(this.Infos.partnerType) === '10852' && !this.Infos.isHmiTrial) {
        EnsureAvevaHmiTrial().then(res => {
          if (res.status === 1) {
            this.refreshUserInfo()
          }
        })
        return
      }
      // 已登录时刷新用户信息，确保 isHmiTrial 同步
      this.refreshUserInfo()
    },
    handleTry() {
      if (!this.$store.state.token){
        this.$toast('请登录后操作!')
        return
      }
      if (this.Infos.isHmiTrial) {
        return
      }
      if (this.applying) return
      this.applying = true
      ApplyHmiTrial().then(res => {
        this.$toast(res.message || (res.status === 1 ? '申请成功' : '申请失败'))
        if (res.status === 1) {
          this.refreshUserInfo()
        }
      }).finally(() => {
        this.applying = false
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.HmiLanding-page{
  background-color: #f8f8f8;
}
.section{
  margin: 94px auto 0;
  max-width: 1200px;
  padding-bottom: 50px;
  @include toMobile() {
    margin-top: vw(36);
    padding: 0 vw(30);
    padding-bottom: vw(54);
  }
}
.section-info{
  display: flex;
  align-items: center;
  gap: 50px;
  @include toMobile() {
    flex-direction: column;
    gap: vw(36);
  }
}
.info-box{
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @include toMobile() {
    gap: vw(40);
    line-height: vw(40);
    font-size: vw(24);
  }
  >.title{
    font-weight: bold;
    color: #6B18A8;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      margin-bottom: -10px;
      height: 2px;
      width: 40px;
      background-color: #B311EF;
      @include toMobile() {
        margin-bottom: vw(-20);
      }
    }
  }
  >.btn{
    color: #909399 !important;
    cursor: pointer;
    align-self: start;
    @include toMobile() {
      margin-top: vw(-10);
    }
  }
}
.info-img{
  width: 532px;
  min-height: 299px;
  display: flex;
  align-items: center;
  @include toMobile() {
    width: 100%;
    min-height: vw(200);
  }
  >.img{
    width: 100%;
    height: auto;
  }
}
.section-title{
  color: #363D42;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  line-height: 72px;
  margin-bottom: 38px;
  @include toMobile() {
    font-size: vw(48);
    line-height: vw(70);
    margin-bottom: vw(46);
  }
}
.section-point{
  margin-top: 94px;
  @include toMobile() {
    margin-top: vw(90);
  }
}
.point-tags{
  display: flex;
  align-items: center;
  gap: 20px;
  @include toMobile() {
    flex-direction: column;
    gap: vw(12);
    align-items: stretch;
  }
  >.tag{
    flex: 1;
    line-height: 58px;
    background-color: #6B18A8;
    text-align: center;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    @include toMobile() {
      line-height: vw(96);
      font-size: vw(32);
    }
  }
}
.point-grid{
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
  margin-top: 35px;
  @include toMobile() {
    margin-top: vw(38);
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: vw(14);
  }
}
.grid-item{
  background-color: #fff;
  padding: 10px 15px 15px;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @include toMobile() {
    gap: vw(40);
    line-height: vw(40);
    font-size: vw(24);
    padding: vw(30);
  }
  >.title{
    font-weight: bold;
    color: #6B18A8;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      margin-bottom: -10px;
      height: 2px;
      width: 40px;
      background-color: #B311EF;
      @include toMobile() {
        margin-bottom: vw(-20);
      }
    }
  }
}
.section-res{
  margin-top: 94px;
  @include toMobile() {
    margin-top: vw(88);
  }
}
.res-items{
  display: flex;
  align-items: center;
  gap: 20px;
  @include toMobile() {
    flex-direction: column;
    gap: vw(14);
    align-items: stretch;
  }
  >.item{
    flex: 1;
    >.icon{
      height: 280px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border: 2px solid #6B18A8;
      >img{
        max-width: 146px;
        max-height: 134px;
      }
      @include toMobile() {
        height: vw(254);
        >img{
          max-width: vw(174);
          max-height: vw(160);
        }
      }
    }
    >.text{
      font-size: 24px;
      color: #fff;
      font-weight: bold;
      line-height: 80px;
      background-color: #6B18A8;
      text-align: center;
      cursor: pointer;
      @include toMobile() {
        font-size: vw(32);
        line-height: vw(96);
      }
    }
  }
}
.section-btn-box{
  display: flex;
  justify-content: center;
  margin-top: 38px;
  >.btn{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 36px;
    gap: 10px;
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 58px;
    background-color: #6B18A8;
    cursor: pointer;
  }
  @include toMobile() {
    margin-top: vw(44);
    >.btn{
      flex: 1;
      line-height: vw(114);
      gap: vw(18);
      font-size: vw(32);
    }
  }
}
</style>